module.exports = __webpack_public_path__ + "img/as_gestion.29be45c5.svg";